import { render, staticRenderFns } from "./all_notifications.vue?vue&type=template&id=d4779cf0&"
import script from "./all_notifications.vue?vue&type=script&lang=js&"
export * from "./all_notifications.vue?vue&type=script&lang=js&"
import style0 from "./all_notifications.vue?vue&type=style&index=0&id=d4779cf0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports